import * as z from "zod/v4";

export const refundExchangeShipping = {
  name: "refundExchangeShipping" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({ success: z.boolean(), error: z.string().optional() }),
};
